import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Input, Output } from '@angular/core';
import { SideNaveActionsTypes, SideNaveData } from '@klickdata/core/mobile';
import { SideNaveResponseData } from '@klickdata/core/mobile/src/mobile.service';
import { AppScope, ResourceTypes } from '@klickdata/core/resource';
import { User, UserService } from '@klickdata/core/user';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-menu-side-resource-managers',
    templateUrl: './menu-side-resource-managers.component.html',
    styleUrls: ['./menu-side-resource-managers.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSideResourceManagersComponent implements OnInit {
    @Input() public navData: SideNaveData;
    ResourceTypes = ResourceTypes;
    AppScope = AppScope;
    @Output() onClose: EventEmitter<SideNaveResponseData> = new EventEmitter();
    SideNaveActionsTypes = SideNaveActionsTypes;
    public managers$: Observable<User[]>;
    constructor(protected userService: UserService) {}

    ngOnInit(): void {
        if (!!this.navData.data.managers?.length) {
            this.managers$ = this.userService.getUsers(
                this.navData.data.managers.map((manager) => manager.id),
                false
            );
        }
    }
    clear() {}
}
